// @ts-nockeck
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// @ts-nockeck
import { ISitePickerViewProps } from '@msdyn365-commerce-modules/site-picker/src/modules/site-picker/./site-picker';
import { Button, Module, Popover } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { GetCookie, SetCookie } from '../../../shared-utils/cookie-utilities';

interface ISitePickerState {
    bottomPopoverOpen: boolean;
    requestedMarket: string;
}
enum Market {
    NZ = 'NZL',
    AU = 'AUS',
    US = 'USA'
}
enum MarketShort {
    NZL = 'NZ',
    AUS = 'AU',
    USA = 'US'
}

const country  = {
    NZL:'New Zealand',
    AUS:'Australia',
    USA: 'United States'
}

/**
 *
 * SitePickerView component
 * @extends {React.PureComponent<ISitePickerViewProps>}
 */
export class SitePickerView extends React.PureComponent<ISitePickerViewProps, ISitePickerState> {
    private _locationInputRef: React.RefObject<HTMLButtonElement>;
    private _cookieExpirationInSeconds: number = this.props.context.app.config.marketPreferenceCookieAge && this.props.context.app.config.marketPreferenceCookieAge || 2592000;
    private _cookieName: string = this.props.context.app.config.marketPreferenceCookieName && this.props.context.app.config.marketPreferenceCookieName || '_msdyn365___market_preference';
    private _geoCookieName: string = 'd365mkt';
    private _hasOpenedCookieName: string = '_msdyn365___market_preference_has_opened';
    constructor(props: ISitePickerViewProps) {
        super(props);
        this._onCountryChange = this._onCountryChange.bind(this);
        this._togglePopover = this._togglePopover.bind(this);
        this._selectMarket = this._selectMarket.bind(this);

        // refs
        this._locationInputRef = React.createRef();

        this.getMarket = this.getMarket.bind(this);
        this.state = {
            bottomPopoverOpen: false,
            requestedMarket: ''
        };
    }
    public componentDidMount(): void {
        const hasOpenedCookie = GetCookie(this.props.context.request.cookies, this._hasOpenedCookieName);

        if (!hasOpenedCookie || hasOpenedCookie !== 'true') {
            const url = this.props.context.request.url && this.props.context.request.url.requestUrl && this.props.context.request.url.requestUrl.href;
            const requestedMarket = this.getMarket(url);
            // Auto-trigger if no market cookie saved and has not opened before
            const marketCookie = GetCookie(this.props.context.request.cookies, this._cookieName);
            if (!marketCookie || (marketCookie && marketCookie !== requestedMarket)) {
                this.setState({
                    bottomPopoverOpen: true,
                    requestedMarket: requestedMarket
                });
            }

            SetCookie(this.props.context.request.cookies, 'true', this._hasOpenedCookieName, this._cookieExpirationInSeconds);
        } 
        else {
            const url = this.props.context.request.url && this.props.context.request.url.requestUrl && this.props.context.request.url.requestUrl.href;
            const requestedMarket = this.getMarket(url);

            this.setState({
                requestedMarket: requestedMarket
            });
        }
    }
    public render(): JSX.Element | null {
        const { SitePicker } = this.props;
        const { requestedMarket } = this.state;

        return (
            <Module {...SitePicker}>
                {this._renderMarketPickerButton()}
                {this._renderMarketPickerPopOver(requestedMarket)}
                {this._renderMarketPickerMobile(requestedMarket)}
            </Module>
        );
    }
    private getMarket = (url: string = ''): string => {
        let indexOfCountry = 3;
        if (url.indexOf('test.') > 0 || url.indexOf('cittab.') > 0) {
            indexOfCountry = 4;
        }
        let market = (url && url.length > 0) 
            ? (url.indexOf('//') > -1 
                ? ((url.split('/')[indexOfCountry] === undefined || url.split('/')[indexOfCountry] === "nz"|| (url.split('/')[indexOfCountry].length > 2 && url.split('/')[indexOfCountry].toLowerCase() !== 'international' && url.split('/')[indexOfCountry].toLowerCase() !== 'intl'&& url.split('/')[indexOfCountry].toLowerCase() !== 'us') || url.split('/')[indexOfCountry] === '') 
                    ? Market.NZ 
                    : url.split('/')[indexOfCountry].toUpperCase()) 
                : Market.NZ) 
            : '';

        if (market === 'AU') {
            market = Market.AU;
        } else if (market.toLowerCase() === 'international' || market.toLowerCase() === 'intl' || market.toLowerCase() === 'us') {   
            market = Market.US;
        }
        return market;
    };

    private _togglePopover(): void {
        this.setState({
            bottomPopoverOpen: !this.state.bottomPopoverOpen
        });
        //scroll to bottom.
        if(!this.state.bottomPopoverOpen) {
            var objDiv = document.getElementsByClassName("msc-modal")[0];
            objDiv.scrollTop = objDiv.scrollHeight;
        }
    }
    private _renderMarketPickerButton(): React.ReactNode {
        const url = this.props.context.request.url && this.props.context.request.url.requestUrl && this.props.context.request.url.requestUrl.href;
        const requestedMarket = this.getMarket(url);
        return (
            <>
                <Button
                    innerRef={this._locationInputRef}
                    className='marketPickerPopoverBtn'
                    aria-describedby='marketPickerPopover'
                    onClick={this._togglePopover}
                    aria-label='Select Delivery Country'
                    aria-expanded={this.state.bottomPopoverOpen}
                >   
                    <span className="mobile-only" >{'Delivery'}</span>
                    <span>{country[requestedMarket]}</span>
                    <span className={`arrow ${this.state.bottomPopoverOpen ? 'arrow-down' : 'arrow-right'}`} />
                {/* <span className='marketText'>{requestedMarket}</span>
                <span className='arrow' /> */}
                </Button>
            </>
        );
    }
    private _renderMarketPickerMobile(requestedMarket: string): React.ReactNode {
        const siteOptions=this.props.config.siteOptions && this.props.config.siteOptions ;
        return (
            <div className={`mobile-site-picker-body ${this.state.bottomPopoverOpen ? 'isOpen' : ''}`}>
                { siteOptions && siteOptions.map((item, index) => (
                <a
                    className=''
                    title={item.siteName}
                    onClick={this._selectMarket}
                    aria-label={item.siteName}
                    href={item.siteRedirectUrl.destinationUrl}
                >
                <div className={`flex-container ${requestedMarket === item.siteName ? 'active' : ''}`}>
                    <span className='text'>{this._mapCountryName(item.siteName)}</span>
                </div>
                </a>
                ))
               }
             </div>
        );
    }

    private _mapCountryName(siteName?: string): string {
        return siteName && country[siteName] || country['INT'];
    }

    private _renderMarketPickerPopOver(requestedMarket: string): React.ReactNode {
        const siteOptions=this.props.config.siteOptions && this.props.config.siteOptions;
        return (
            <Popover
                id='marketPickerPopover'
                className='popover show market-picker-popover bs-popover-bottom'
                placement='bottom'
                isOpen={this.state.bottomPopoverOpen}
                target={this._locationInputRef}
                // toggle={this._togglePopover}
            >

            <div className='popover-body'>
                <p>Select your delivery country</p>
                { siteOptions && siteOptions.map((item, index) => (
                <a
                    className=""
                    title={item.siteName}
                    onClick={this._selectMarket}
                    aria-label={item.siteName}
                    href={item.siteRedirectUrl.destinationUrl}
                >
                <div className={`flex-container ${requestedMarket === item.siteName ? 'active' : ''}`}>
                    <span className='text'>{this._mapCountryName(item.siteName)}</span>
                    <span className='fa fa-chevron-right'/>
                </div>
                </a>
                ))
               }
             </div>
            </Popover>
        );
    }


    private _selectMarket(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        const redirectUrl = event.currentTarget.href;
        let market = Market.NZ;
       
        if(event.currentTarget.text === 'Australia') {
            market = Market.AU;
        } else if(event.currentTarget.text === 'United States') {
            market = Market.US;
        } else {
            market = Market.NZ;
        }
        const url = this.props.context.request.url && this.props.context.request.url.requestUrl && this.props.context.request.url.requestUrl.href;
        const requestedMarket = this.getMarket(url);
        if (market && market === requestedMarket) {
            // SAVE COOKIE ANYWAY
            SetCookie(this.props.context.request.cookies, market, this._cookieName, this._cookieExpirationInSeconds);
            SetCookie(this.props.context.request.cookies, 'false', this._hasOpenedCookieName, this._cookieExpirationInSeconds);
            SetCookie(this.props.context.request.cookies, MarketShort[market], this._geoCookieName, this._cookieExpirationInSeconds)
            let url = redirectUrl.split('?')[0]
            SetCookie(this.props.context.request.cookies, url, '_msdyn365___site_', this._cookieExpirationInSeconds)

            this._togglePopover();
            return;
        }
        this._onCountryChange(market, redirectUrl);
    }
    private _onCountryChange(market: Market, redirectUrl:string): void {
        if (market) {
            !this.props.context.request.cookies.isConsentGiven() && this.props.context.request.cookies.setConsentCookie();
            SetCookie(this.props.context.request.cookies, market, this._cookieName, this._cookieExpirationInSeconds);
            SetCookie(this.props.context.request.cookies, MarketShort[market], this._geoCookieName, this._cookieExpirationInSeconds)
            let url = redirectUrl.split('?')[0]
            SetCookie(this.props.context.request.cookies, url, '_msdyn365___site_', this._cookieExpirationInSeconds)
            window.location.assign(redirectUrl);
        }
    }
}
export default SitePickerView;
